var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7623 2.68164C16.6364 2.68164 18.3327 4.33547 18.3327 7.16647H14.8068V7.19536C13.1704 7.19536 11.8438 8.48871 11.8438 10.0841C11.8438 11.6796 13.1704 12.9729 14.8068 12.9729H18.3327V13.2329C18.3327 16.0278 16.6364 17.6816 13.7623 17.6816H6.23639C3.36231 17.6816 1.66602 16.0278 1.66602 13.2329V7.13036C1.66602 4.33547 3.36231 2.68164 6.23639 2.68164H13.7623ZM17.7105 8.40865C18.0541 8.40865 18.3327 8.68025 18.3327 9.0153V11.1241C18.3287 11.4575 18.0524 11.7268 17.7105 11.7308H14.8734C14.045 11.7416 13.3206 11.1886 13.1327 10.4019C13.0386 9.91355 13.1707 9.40961 13.4936 9.02515C13.8165 8.6407 14.2971 8.41504 14.8068 8.40865H17.7105ZM15.2068 9.38361H14.9327C14.7644 9.38168 14.6024 9.44551 14.4827 9.56084C14.363 9.67617 14.2956 9.83341 14.2956 9.99748C14.2956 10.3417 14.5797 10.6218 14.9327 10.6258H15.2068C15.5586 10.6258 15.8438 10.3477 15.8438 10.0047C15.8438 9.66169 15.5586 9.38361 15.2068 9.38361ZM10.3179 5.9243H5.61416C5.26521 5.92428 4.98118 6.19797 4.97713 6.53816C4.97713 6.88237 5.26114 7.16252 5.61416 7.16647H10.3179C10.6697 7.16647 10.9549 6.8884 10.9549 6.54539C10.9549 6.20237 10.6697 5.9243 10.3179 5.9243Z",
    fill: "#B4BBCA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet2);
export default __webpack_public_path__ + "static/media/wallet2.db5afdcc2ef4cca723e4881b4253fdbe.svg";
export { ForwardRef as ReactComponent };